import type {
  VideoClipPipPosition,
  VideoClipPipShape,
  VideoClipPipSize,
} from "@circle-react/components/shared/VideoClipRecorder/hooks/useVideoClipSettingsStore";

import type { SegmentOption } from "./utils";

export const PIP_SHAPE_OPTIONS: Array<SegmentOption<VideoClipPipShape>> = [
  { labelKey: "tiptap.video_clip.settings.pip_shape.round", value: "round" },
  { labelKey: "tiptap.video_clip.settings.pip_shape.square", value: "square" },
];

export const PIP_SIZE_OPTIONS: Array<SegmentOption<VideoClipPipSize>> = [
  { labelKey: "tiptap.video_clip.settings.pip_size.small", value: "small" },
  { labelKey: "tiptap.video_clip.settings.pip_size.medium", value: "medium" },
  { labelKey: "tiptap.video_clip.settings.pip_size.large", value: "large" },
];

export const PIP_POSITION_OPTIONS: Array<SegmentOption<VideoClipPipPosition>> =
  [
    {
      icon: "pip-bottom-left",
      labelKey: "tiptap.video_clip.settings.pip_position.bottom_left",
      value: "bottom-left",
    },
    {
      icon: "pip-top-left",
      labelKey: "tiptap.video_clip.settings.pip_position.top_left",
      value: "top-left",
    },
    {
      icon: "pip-top-right",
      labelKey: "tiptap.video_clip.settings.pip_position.top_right",
      value: "top-right",
    },
    {
      icon: "pip-bottom-right",
      labelKey: "tiptap.video_clip.settings.pip_position.bottom_right",
      value: "bottom-right",
    },
  ];
